"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ComponentVerticalSpacing = _interopRequireDefault(require("../helpers/ComponentVerticalSpacing"));
var _Carousel = _interopRequireDefault(require("../Carousel/Carousel"));
var _FlexHero = _interopRequireDefault(require("./FlexHero/FlexHero"));
var _FlexTrustPilot = _interopRequireDefault(require("./FlexTrustPilot/FlexTrustPilot"));
var _FlexPageIntro = _interopRequireDefault(require("./FlexPageIntro/FlexPageIntro"));
var _FlexProductTabs = _interopRequireDefault(require("./FlexProductTabs/FlexProductTabs"));
var _FlexTextGrid = _interopRequireDefault(require("./FlexTextGrid/FlexTextGrid"));
var _FlexRow = _interopRequireDefault(require("./FlexRow/FlexRow"));
var _FlexBanner = _interopRequireDefault(require("./FlexBanner/FlexBanner"));
var _FlexTextDecorationRow = _interopRequireDefault(require("./FlexTextDecorationRow"));
var _FlexBlogPostCarousel = _interopRequireDefault(require("./FlexBlogPostCarousel/FlexBlogPostCarousel"));
var _FlexBlogPostSlider = _interopRequireDefault(require("./FlexBlogPostSlider/FlexBlogPostSlider"));
var _FlexLinkButton = _interopRequireDefault(require("./FlexLinkButton/FlexLinkButton"));
var _FlexWeeklyLineups = _interopRequireDefault(require("./FlexWeeklyLineups/FlexWeeklyLineups"));
var _FlexInfoCards = _interopRequireDefault(require("./FlexInfoCards/FlexInfoCards"));
var _FlexFaq = _interopRequireDefault(require("./FlexFaq/FlexFaq"));
var _FlexTabs = _interopRequireDefault(require("./FlexTabs/FlexTabs"));
var _FlexDestinationMap = _interopRequireDefault(require("./FlexDestinationMap/FlexDestinationMap"));
var _FlexHighlightGrid = _interopRequireDefault(require("./FlexHighlightGrid/FlexHighlightGrid"));
var _FlexSliderAndText = _interopRequireDefault(require("./FlexSliderAndText/FlexSliderAndText"));
var _FlexTierCards = _interopRequireDefault(require("./FlexTierCards/FlexTierCards"));
var _FlexDestinationCardsSlider = _interopRequireDefault(require("./FlexDestinationCardsSlider/FlexDestinationCardsSlider"));
var _FlexReviews = _interopRequireDefault(require("./FlexReviews/FlexReviews"));
var _FlexPriceCard = _interopRequireDefault(require("./FlexPriceCard/FlexPriceCard"));
var _FlexSignUp = _interopRequireDefault(require("./FlexSignUp/FlexSignUp"));
var _FlexForm = _interopRequireDefault(require("./FlexForm/FlexForm"));
var _FlexStickyBanner = _interopRequireDefault(require("./FlexStickyBanner/FlexStickyBanner"));
var _FlexEventWeeks = _interopRequireDefault(require("./FlexEventWeeks/FlexEventWeeks"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // import FlexExpect from './FlexExpect/FlexExpect';
// import FlexDestinations from './FlexDestinations/FlexDestinations';
// import FlexHighlightGrid from './FlexHighlightGrid/FlexHighlightGrid';
// import FlexMediaGrid from './FlexMediaGrid/FlexMediaGrid';
// import FlexIntro from './FlexIntro/FlexIntro';
// import FlexTestimonialSlider from './FlexTestimonialSlider/FlexTestimonialSlider';
// import FlexMusicBlogCarousel from './FlexMusicBlogCarousel/FlexMusicBlogCarousel';
// import FlexLineupCard from './FlexLineupCard/FlexLineupCard';
// import FlexLineupGrid from './FlexLineupGrid/FlexLineupGrid';
// import FlexAppIntro from './FlexAppIntro/FlexAppIntro';
// import FlexAccordion from './FlexAccordion/FlexAccordion';
// import FlexAppInfo from './FlexAppInfo/FlexAppInfo';
// import FlexBlocks from './FlexBlocks/FlexBlocks';
// import FlexSoundcloud from './FlexSoundcloud/FlexSoundcloud';
// import FlexFaq from './FlexFaq/FlexFaq';
// import FlexCheckmarkList from './FlexCheckmarkList/FlexCheckmarkList';
// import FlexSimpleCardsRow from './FlexSimpleCardsRow/FlexSimpleCardsRow';
// import FlexHighlightsRow from './FlexHighlightsRow/FlexHighlightsRow';
// import FlexTimeLine from './FlexTimeLine/FlexTimeLine';
// import FlexSignUp from './FlexSignUp/FlexSignUp';
// import FlexCustomFlats from './FlexCustomFlats/FlexCustomFlats';
// import '../../sass/destinationmap.scss';
var FlexibleComponents = /*#__PURE__*/function (_React$PureComponent) {
  function FlexibleComponents() {
    (0, _classCallCheck2["default"])(this, FlexibleComponents);
    return _callSuper(this, FlexibleComponents, arguments);
  }
  (0, _inherits2["default"])(FlexibleComponents, _React$PureComponent);
  return (0, _createClass2["default"])(FlexibleComponents, [{
    key: "renderComponent",
    value: function renderComponent(data) {
      var layout = data.acf_fc_layout;
      var key = JSON.stringify(data);
      var component;
      if (layout === 'hero') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexHero["default"], data);
      } else if (layout === 'slider') {
        var _data$slides;
        component = /*#__PURE__*/_react["default"].createElement(_Carousel["default"], null, (_data$slides = data.slides) === null || _data$slides === void 0 ? void 0 : _data$slides.map(function (slide) {
          return /*#__PURE__*/_react["default"].createElement(_FlexHero["default"], (0, _extends2["default"])({
            key: JSON.stringify(slide)
          }, slide));
        }));
      } else if (layout === 'trustpilot') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexTrustPilot["default"], null);
      } else if (layout === 'flex_page_intro') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexPageIntro["default"], {
          heading: data.heading,
          subheading: data.subheading,
          topText: data.topText,
          noTop: data.noTop,
          noBottom: data.noBottom
        });
      } else if (layout === 'flex_product_tabs') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexProductTabs["default"], {
          data: data
        });
      } else if (layout === 'flex_text_grid') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexTextGrid["default"], {
          data: data
        });
      } else if (layout === 'flex_banner') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexBanner["default"], {
          data: data
        });
      } else if (layout === 'flex_text_decoration_row') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexTextDecorationRow["default"], {
          data: data
        });
      } else if (layout === 'flex_blog_post_carousel') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexBlogPostCarousel["default"], {
          title: data.title,
          highlights: data.highlights,
          slidesCount: data.slides_count,
          showSubtitle: data.show_subtitle,
          postCategory: data.post_category,
          postTag: data.post_tag,
          bgImage: data.background_image,
          centerTitle: data.center_title
        });
      } else if (layout === 'flex_blog_post_slider') {
        var title = data.title,
          postCategory = data.post_category,
          postTag = data.post_tag;
        component = /*#__PURE__*/_react["default"].createElement(_FlexBlogPostSlider["default"], {
          title: title,
          postCategory: postCategory,
          postTag: postTag
        });
      } else if (layout === 'flex_link_button') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexLinkButton["default"], {
          text: data.text,
          position: data.position,
          url: data.url,
          openOnNewWindow: data.openOnNewWindow,
          color: data.color
        });
      } else if (layout === 'flex_weekly_lineups') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexWeeklyLineups["default"], null);
      } else if (layout === 'custom_html') {
        component = /*#__PURE__*/_react["default"].createElement("div", {
          dangerouslySetInnerHTML: {
            __html: data.html
          }
        });
      } else if (layout === 'info_cards') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexInfoCards["default"], {
          infoCards: data.infoCards
        });
      } else if (layout === 'flex_faq') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexFaq["default"], {
          faq: data.faq,
          title: data.title
        });
      } else if (layout === 'tabs') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexTabs["default"], {
          tabs: data.tabs
        });
      } else if (layout === 'stops') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexDestinationMap["default"], {
          days: data.stops,
          routeText: data.text,
          title: data.title,
          stopType: "name"
        });
      } else if (layout === 'highlights') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexHighlightGrid["default"], {
          title: data.title,
          highlights: data.highlights
        });
      } else if (layout === 'sliderandtext') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexSliderAndText["default"], {
          slides: data.slides,
          content: data.content,
          title: data.title,
          reorderOnMobile: data.reorder_on_mobile
        });
      } else if (layout === 'tiers') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexTierCards["default"], {
          tierCards: data.tiers
        });
      } else if (layout === 'eventweeks') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexEventWeeks["default"], {
          destinationId: data.destination_id,
          title: data.title,
          customWeeks: data.custom_weeks
        });
      } else if (layout === 'flex_destination_cards_slider') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexDestinationCardsSlider["default"], {
          destinations: this.props.destinations
        });
      } else if (layout === 'flex_reviews') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexReviews["default"], {
          title: data.title,
          reviews: data.reviews
        });
      } else if (layout === 'flex_price_card') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexPriceCard["default"], {
          cta: data.cta,
          title: data.title,
          image: data.image,
          text: data.text
        });
      } else if (layout === 'flex_row') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexRow["default"], {
          data: data
        });
      } else if (layout === 'flex_signup') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexSignUp["default"], {
          data: data
        });
      } else if (layout === 'flex_form') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexForm["default"], {
          template: data.template
        });
      } else if (layout === 'flex_sticky_banner') {
        component = /*#__PURE__*/_react["default"].createElement(_FlexStickyBanner["default"], {
          text: data.text,
          link: data.link,
          noMarginTop: data.noMarginTop,
          noMarginBottom: data.noMarginBottom
        });
      }
      // } else if (layout === 'what_is_tyw') {
      //   component = <FlexExpect />;
      // } else if (layout === 'all_destinations') {
      //   component = <FlexDestinations size={data.size} brand={data.brand} title={data.title} text={data.subtitle} />;
      // } else if (layout === 'media') {
      //   component = <FlexMediaGrid media={data.media} />;
      // } else if (layout === 'eventweeks') {
      //   component = (
      //     <FlexEventWeeks destinationId={data.destination_id} title={data.title} customWeeks={data.custom_weeks} />
      //   );
      // } else if (layout === 'intro') {
      //   component = (
      //     <FlexIntro facts={data.facts} info={data.info} book={data.book} title={data.title} text={data.text} />
      //   );
      // } else if (layout === 'trustpilot') {
      //   component = <FlexTrustPilot />;
      // } else if (layout === 'testimonials_slider') {
      //   component = <FlexTestimonialSlider slides={data.slides} />;
      // } else if (layout === 'flex_music_blog_carousel') {
      //   component = <FlexMusicBlogCarousel data={data} />;
      // } else if (layout === 'flex_lineup_card') {
      //   component = <FlexLineupCard image={data.image} title={data.title} content={data.content} url={data.url} />;
      // } else if (layout === 'flex_lineup_grid') {
      //   component = (
      //     <FlexLineupGrid title={data.title} showsubtitle={data.showsubtitle} posts={data.posts} cols={data.cols} />
      //   );
      // } else if (layout === 'flex_app_intro') {
      //   component = (
      //     <FlexAppIntro
      //       title={data.title}
      //       content={data.content}
      //       appImage={data.app_image}
      //       bgImage={data.background_image}
      //       features={data.features}
      //     />
      //   );
      // } else if (layout === 'flex_accordion') {
      //   component = <FlexAccordion items={data.items} />;
      // } else if (layout === 'flex_app_info') {
      //   component = <FlexAppInfo bgImage={data.bgimage} title={data.title} image={data.image} items={data.items} />;
      // } else if (layout === 'flex_blocks') {
      //   component = <FlexBlocks title={data.title} items={data.items} />;
      // } else if (layout === 'flex_soundcloud') {
      //   component = <FlexSoundcloud data={data} />;
      // } else if (layout === 'flex_checkmark_list') {
      //   component = <FlexCheckmarkList data={data} />;
      // } else if (layout === 'flex_simple_cards_row') {
      //   component = <FlexSimpleCardsRow data={data} />;
      // } else if (layout === 'flex_highlights_row') {
      //   component = <FlexHighlightsRow data={data} />;
      // } else if (layout === 'flex_timeline') {
      //   component = <FlexTimeLine data={data} />;
      // } else if (layout === 'flex_signup') {
      //   component = <FlexSignUp data={data} />;
      // } else if (layout === 'flex_custom_flats') {
      //   component = <FlexCustomFlats data={data} />;
      // }

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: key
      }, component);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var components = this.props.components;
      // if it is first component then remove spacing from top
      return components.map(function (component, i) {
        return /*#__PURE__*/_react["default"].createElement(_ComponentVerticalSpacing["default"], {
          key: JSON.stringify(component),
          noTop: i === 0
        }, _this.renderComponent(component));
      });
    }
  }]);
}(_react["default"].PureComponent);
var _default = exports["default"] = FlexibleComponents;
FlexibleComponents.propTypes = {
  components: _propTypes["default"].array.isRequired
};